import * as React from 'react'
import './Sizer.css'

// react-sizeme doesn't have the API I like

import elementResizeDetectorMaker from 'element-resize-detector'

export interface Size {
  width: number,
  height: number,
}

class Sizer extends React.Component<{
  children: React.ReactNode,
  owner?: React.Component,
  stateName?: string,
  stateKey?: string,
  onSize?: (size: Size) => void,

  className?: string,
}> {

  state = {size: undefined as Size | undefined}
  ref = React.createRef<HTMLDivElement>()
  resizeDetector = elementResizeDetectorMaker({strategy: 'scroll'})
  backupInterval: number

  render() {
    const {children, className = ""} = this.props

    return <div className={"Sizer " + className} ref={this.ref}>
      {children}
    </div>
  }

  componentDidMount() {
    if (!this.ref.current) { return }
    this.resizeDetector.listenTo(this.ref.current, this.onResizeDetected)
    this.backupInterval = window.setInterval(this.onResizeDetected, 1)  // TODO: backup?
  }

  componentWillUnmount() {
    const {owner, stateName, stateKey} = this.props

    if (this.ref.current) {
      this.resizeDetector.uninstall(this.ref.current)
    }
    window.clearInterval(this.backupInterval)

    if (owner && stateName && stateKey) {
      delete owner.state[stateName][stateKey]
      owner.setState({[stateName]: owner.state[stateName]})
    }
  }

  onResizeDetected = () => {
    const {onSize, owner, stateName, stateKey} = this.props

    const element = this.ref.current
    if (!element) { return }

    const width = element.offsetWidth
    const height = element.offsetHeight
    const size = {width, height}

    if (this.state.size &&
        size.width === this.state.size.width &&
        size.height === this.state.size.height) {
      return
    }

    this.setState({size})
    if (onSize) {
      onSize(size)
    }
    if (owner && stateName) {
      if (stateKey) {
        // We are supposed to put the size into owner.state[stateName][stateKey]
        if (!owner.state[stateName]) {
          owner.state[stateName] = {}
        }
        owner.state[stateName][stateKey] = size
        owner.setState({[stateName]: owner.state[stateName]})
      } else {
        // We are supposed to put the size into owner.state[stateName]
        owner.setState({[stateName]: size})
      }
    }
  }
}

export default Sizer;



// WEBPACK FOOTER //
// ./src/view/Sizer.tsx